function nameFilter(name: string, phrase: string) {
  return name.toLowerCase().includes(phrase.toLowerCase());
}

export {
  nameFilter
};
